import { useEffect, useState } from 'react';
import { handleRenderError, withErrorBoundary } from '@utils/errorHandler';
import { API } from '@utils';

export const TicketIcon = (properties: {
  index?: number;
  attendeeTicket: IAttendeeTicket;
  activeIdx?: number;
}) => {
  try {
    const [attendee, setAttendee] = useState<IAttendee>();

    useEffect(
      withErrorBoundary(() => {
        API.get<IAttendee>(
          `Attendee/Get/${properties.attendeeTicket.AttendeeID}`
        )?.then(response => {
          setAttendee(response);
        });
      }),
      [properties.attendeeTicket, properties.activeIdx]
    );

    return (
      <div
        className={`ticketQuantityIcon ${
          properties.index && properties.activeIdx
            ? properties.index === properties.activeIdx
              ? 'active'
              : properties.index < properties.activeIdx
              ? 'completed'
              : ''
            : 'completed'
        }`}
      >
        {attendee?.FirstName && attendee?.Photo ? (
          <img style={{ width: 40 }} src={attendee.Photo} alt='' />
        ) : (
          properties.index
        )}
      </div>
    );
  } catch (error) {
    return handleRenderError(error);
  }
};
